import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { formatDate } from "../../../utils/commonFunctions";
import { Button } from "reactstrap";
import { commentIcon } from "../../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CircularAvatar } from "../../commons";
type AppProps = {
  data: any;
  tableHeader: [] | TableHeadersType[];
  history?: any;
  activeTab?:string;
};

const statusApprovalPendingTypeStyle = () => {
  return {
    padding: "4px 12px",
    color: "#407EEE",
    background: "#E5EEFE",
    borderRadius: "16px",
    width: "20px",
  };
};

const statusReRejectTypeStyle = () => {
  return {
    padding: "4px 12px",
    color: "#744bd1",
    background: "#ede6fc",
    borderRadius: "16px",
    width: "20px",
  };
};

const blank = () => {
  return {};
};

const statusApprovedTypeStyle = () => {
  return {
    padding: "4px 12px",
    color: "#744bd1",
    background: "#ede6fc",
    borderRadius: "16px",
    width: "20px",
  };
};
const SchedulingManagerViewNewRequestsListTable = ({
  data,
  tableHeader,
  history,
  activeTab
}: AppProps) => {
  const handleShowViewPage = (id: any) => {
    if(activeTab){
      localStorage.setItem('currentTab' , activeTab)
    }
    history.push({
      pathname: `manager/view-request/${id}`,
      state: { id ,  activeTab},

    });
  };
  return (
    <>
      {data?.length > 0 &&
        data?.map((el: any) => {
          return (
            <tr className="text-left">
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value == "employee_name") {
                    return (
                      <td className="text-left">
                        <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="mr-2">
                           <CircularAvatar
                            name={el?.created_by?.name}
                            image={
                              el?.created_by?.profile_pic &&
                              el?.created_by.profile_pic?.file_url
                            }
                          />
                        </div>
                        <div>{el?.created_by?.name}</div>
                      </div>
                      </td>
                    );
                  } else if (header?.value == "job_type") {
                    return (
                      <td className="text-left">
                        {/* {`${
                    el?.job?.job_id+`_`+
                          el?.job?.job_type +
                          `_` +
                          formatDate(el?.job?.period_ended)
                      }`} */}
                        {(
                          (el?.job?.job_id !== undefined
                            ? `${el?.job?.job_id}_`
                            : "") +
                          (el?.job?.job_type !== undefined
                            ? `${el?.job?.job_type}_`
                            : `${el?.future_job?.job_type}`) +
                          formatDate(
                            el?.job?.period_ended !== undefined
                              ? el?.job?.period_ended
                              : el.future_job?.period_ended
                          )
                        )?.length > 35 ? (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-open-item">
                                {(el?.job?.job_id !== undefined
                                  ? `${el?.job?.job_id}_`
                                  : "") +
                                  (el?.job?.job_type !== undefined
                                    ? `${el?.job?.job_type}_`
                                    : `${el?.future_job?.job_type}`) +
                                  formatDate(
                                    el?.job?.period_ended !== undefined
                                      ? el?.job?.period_ended
                                      : el.future_job?.period_ended
                                  )}
                              </Tooltip>
                            }
                          >
                            <div style={{ width: "100%" }}>
                              {(
                                (el?.job?.job_id !== undefined
                                  ? `${el?.job?.job_id}_`
                                  : "") +
                                (el?.job?.job_type !== undefined
                                  ? `${el?.job?.job_type}_`
                                  : `${el?.future_job?.job_type}`) +
                                formatDate(
                                  el?.job?.period_ended !== undefined
                                    ? el?.job?.period_ended
                                    : el.future_job?.period_ended
                                )
                              )?.slice(0, 35) + "..."}
                            </div>
                          </OverlayTrigger>
                        ) : (
                          (el?.job?.job_id !== undefined
                            ? `${el?.job?.job_id}_`
                            : "") +
                          (el?.job?.job_type !== undefined
                            ? `${el?.job?.job_type}_`
                            : `${el?.future_job?.job_type}`) +
                          formatDate(
                            el?.job?.period_ended !== undefined
                              ? el?.job?.period_ended
                              : el.future_job?.period_ended
                          )
                        )}
                      </td>
                    );
                  } else if (header?.value == "client") {
                    return (
                      <td className="text-left">
                        {`${el?.client_name} (${el?.client_code})`}
                      </td>
                    );
                  } else if (header?.value == "target_end_date") {

                    // const formattedDate = formatDate(el?.job?.target_end_date!== undefined?el?.job?.target_end_date:el?.future_job?.target_end_date);

                    return (
                      <td className="text-left">
                        { el?.job?.target_end_date?formatDate(el?.job?.target_end_date):el?.future_job?.target_end_date?formatDate(el?.future_job?.target_end_date) : "--/--"}
                      </td>
                    );
                  } else if (header?.value == "estimated_hours") {
                    return (
                      <td className="text-left" style={{ maxWidth: "120px" }}>
                        {el?.total_hours}
                      </td>
                    );
                  } else if (header?.value == "status") {
                    return (
                      <td className="text-left" style={{ minWidth: "160px" }}>
                        <span
                          style={
                            el?.schedule_status === 1
                              ? statusApprovalPendingTypeStyle()
                              : el?.schedule_status === 2
                              ? statusReRejectTypeStyle()
                              : el?.schedule_status === 3
                              ? statusApprovedTypeStyle()
                              : blank()
                          }
                        >
                          {el?.schedule_status === 1
                            ? "Approval Pending"
                            : el?.schedule_status === 2
                            ? "Re-Estimate"
                            : el?.schedule_status === 3
                            ? "Approved"
                            : ""}
                        </span>
                      </td>
                    );
                  } else if (header?.value == "action") {
                    return (
                      <td className="text-left" style={{ minWidth: "50px" }}>
                        <div className="d-flex">
                          {
                            <span className="d-inline-block pointer">
                              <button
                                className="btn btn-outline-danger ouline-button-hover"
                                onClick={() => handleShowViewPage(el?._id)}
                              >
                                View
                              </button>

                              {/* <img
                                className="ml-2"
                                src={commentIcon}
                                alt="comment-icon"
                              /> */}
                            </span>
                          }
                        </div>
                      </td>
                    );
                  }
                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default SchedulingManagerViewNewRequestsListTable;
